import { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Select,
  DatePicker,
  Alert,
} from "antd";
import moment from "moment";

import SendHostEmail from "./SendHostEmail";
import candidateLookup from "../../services/candidateLookupService";
import api from "../../services/nysService";
import commonLookupAPI from "../../services/commonLookupService";

import { recordError } from "../../utils/logService";
import RejectCandidate from "./RejectCandidate";

import {
  Messages,
  Notify,
  openNotification,
  util,
} from '@seims/shared';

const PlacementInformation = ({
  currentStatus,
  setCurrentStatus,
  userId,
  candidate,
  exitDetails,
  intake,
}) => {
  const [visible, setVisible] = useState(false);
  const [visibleReject, setVisibleReject] = useState(false);
  const [statuses, setStatuses] = useState([]);
  const [label, setLabel] = useState("Placement Date");
  const [provinces, setProvince] = useState([]);
  const [exitDirections, setExitDirections] = useState([]);
  const [dateChange, setDateChange] = useState();
  const modalType = Object.freeze({
    REJECT: "reject",
    PLACEMENT: "placement",
  });
  const [activeModal, setActiveModal] = useState(modalType.PLACEMENT);

  // const [currentStatus, setCurrentStatus] = useState(placementStatus);
  const allowPlacement = useState(["Submitted", "In Progress"]);

  const formItemLayout = {
    labelCol: {
      span: 12,
    },
    wrapperCol: {
      span: 18,
    },
    layout: "vertical",
  };

  const { Option } = Select;
  const [form] = Form.useForm();
  const [formExit] = Form.useForm();
  const formName = "PlacementInformation";
  const formNameExit = "ExitInformation";

  useEffect(() => {
    getPlacementStatus();
    getExitDirection();
    getProvinces();
    prePopulateExitDetails();
  }, [currentStatus]);

  const prePopulateExitDetails = () => {
    try {
      if (!util.isEmpty(exitDetails)) {
        formExit.setFieldsValue({
          exitDirection: exitDetails.direction,
          effectiveDate: moment(exitDetails.effectiveDate),
        });
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getPlacementStatus = async () => {
    try {
      const response = await candidateLookup.getPlacementStatus();
      if (response) {
        const { data } = response;
        setStatuses(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getExitDirection = async () => {
    try {
      const response = await candidateLookup.getExitDirection();
      if (response) {
        const { data } = response;
        setExitDirections(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getProvinces = async () => {
    try {
      const response = await commonLookupAPI.getProvinces();
      if (response) {
        const { data } = response;
        data.sort((a, b) => a.key - b.key);
        setProvince(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const showModal = (value) => {
    setActiveModal(modalType.PLACEMENT);
    setVisible(value);
  };

  const showRejectionModal = (value) => {
    setActiveModal(modalType.REJECT);
    setVisible(value);
  };

  const onSubmitPlacement = async (values) => {
    const placement = {
      placedProvince: values.placedProvince,
      effectiveDate: moment(values.effectiveDate).format("YYYY-MM-DD"),
      userId: userId,
      intake: intake,
    };

    var msg;
    var action = "Placement status";

    try {
      const response = await api.updatePlacementStatus(placement);

      //!TEMPORARY STATUS 204
      if (response.status == 204) {
        msg = util.parseMessage(Messages.UPDATE_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);
        return;
      }

      if (response.status == 200 || response.status == 201) {
        msg = util.parseMessage(Messages.UPDATE_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);
        const { data } = response;
        setCurrentStatus(data.value);
        form.resetFields();
        return;
      }

      msg = util.parseMessage(Messages.UPDATE_FAILURE, action);
      openNotification(action, msg, Notify.ERROR);
    } catch (error) {
      msg = util.parseMessage(Messages.UPDATE_FAILURE, action);

      openNotification(action, msg, Notify.ERROR);
      recordError(error);
    }
  };

  const onSubmitExit = async (values) => {
    const exit = {
      exitDirection: values.exitDirection,
      effectiveDate: moment(values.effectiveDate).format("YYYY-MM-DD"),
      userId: userId,
      intake: intake,
    };

    var msg;
    var action = "Placement status";

    try {
      const response = await api.updateExitDirection(exit);

      //!TEMPORARY STATUS 204
      if (response.status == 204) {
        msg = util.parseMessage(Messages.UPDATE_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);
        return;
      }

      if (response.status == 200 || response.status == 201) {
        msg = util.parseMessage(Messages.UPDATE_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);
        form.resetFields();
        const { data } = response;
        setCurrentStatus(data.value);
        return;
      }

      msg = util.parseMessage(Messages.UPDATE_FAILURE, action);
      openNotification(action, msg, Notify.ERROR);
    } catch (error) {
      msg = util.parseMessage(Messages.UPDATE_FAILURE, action);
      openNotification(action, msg, Notify.ERROR);
      recordError(error);
    }
  };

  const onDateChange = (value) => {
    var changeDate = moment(value).format("YYYY-MM-DD");
    setDateChange(changeDate);
  };

  const onChangeExitDirection = (selected) => {
    const selectedStatus = exitDirections.find(
      (record) => record.key === selected
    );

    form.setFieldsValue({ exitDirection: selectedStatus });
  };

  const onProvinceChange = (selected) => {
    const selectedProvince = provinces.find((record) => record.key == selected);
    form.setFieldsValue({ placedProvince: selectedProvince });
  };

  const checkStatus = (status) => {
    setCurrentStatus(status);
  };
  return (
    <>
      {(currentStatus === "Submitted" ||
        currentStatus === "In Progress" ||
        currentStatus === "In Review") && (
        <>
          <h1 className="center-align">Placement Information</h1>

          <br />
        </>
      )}
      {(currentStatus === "Submitted" ||
        currentStatus === "In Progress" ||
        currentStatus === "In Review") && (
        <>
          {currentStatus === "Submitted" && (
            <Row gutter={16} justify="center" align="middle">
              
              <Col xs={24} md={8}>
                <Card
                  key="2"
                  style={{
                    minHeight: "200px",
                    justifyContent: "center",
                    marginBottom: 10,
                  }}
                  title="Forward Candidate Profile Information"
                >
                  <div className="center-align">
                    <Button
                      key="send-host"
                      // htmlType="submit"
                      type="primary"
                      className="blue"
                      onClick={() => showModal(true)}
                      style={{
                        marginTop: 22,
                      }}
                    >
                      Send Host Email
                    </Button>

                    <Button
                      key="reject"
                      // htmlType="submit"
                      type="danger"
                      // className="blue"
                      onClick={() => showRejectionModal(true)}
                      style={{
                        marginTop: 22,
                        margin: "0 10px",
                      }}
                    >
                      Reject
                    </Button>

                    <SendHostEmail
                      show={visible && activeModal === modalType.PLACEMENT}
                      onShow={showModal}
                      userId={userId}
                      currentStatus={currentStatus}
                      setCurrentStatus={checkStatus}
                      intake={intake}
                      key="sendHostEmailmodal"
                    />
                    <RejectCandidate
                      open={visible && activeModal === modalType.REJECT}
                      candidate={candidate}
                      setVisible={setVisible}
                      userId={userId}
                      currentStatus={currentStatus}
                      setCurrentStatus={checkStatus}
                      intake={intake}
                      key="rejectCandidate"
                    />
                  </div>
                </Card>
              </Col>
             
            </Row>
          )}
          {currentStatus !== "Submitted" && (
            <>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={18}>
                  <Card
                    key="1"
                    style={{
                      minHeight: "200px",
                      justifyContent: "center",
                      marginBottom: 10,
                    }}
                    title={<b>Place Candidate</b>}
                  >
                    <Form
                      {...formItemLayout}
                      name={formName}
                      form={form}
                      onFinish={onSubmitPlacement}
                      disabled={currentStatus === "Submitted"}
                    >
                      <Row>
                        <Col span={10}>
                          <Form.Item
                            name="placedProvince"
                            label="Placed Province"
                            rules={[
                              {
                                required: true,
                                message: "Please select the placed Province",
                              },
                            ]}
                          >
                            <Select onChange={onProvinceChange}>
                              {provinces.map((province) => (
                                <Option key={province.key}>
                                  {province.value}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item
                            name="effectiveDate"
                            label={label}
                            rules={[
                              {
                                required: true,
                                message: "Please pick placement date",
                              },
                            ]}
                          >
                            <DatePicker
                              onChange={onDateChange}
                              // disabledDate={disabledDates}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item
                            style={{
                              marginTop: 23,
                            }}
                          >
                            <Button
                              key="3"
                              htmlType="submit"
                              form={formName}
                              type="primary"
                            >
                              Save
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                      {currentStatus === "Submitted" && (
                        <Alert
                          description="The Save button will be activated after you send host organisation an email."
                          type="info"
                          showIcon
                          key="alert-info"
                        />
                      )}
                    </Form>
                  </Card>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={24} md={18}>
                  <Card
                    key="2"
                    style={{
                      minHeight: "200px",
                      justifyContent: "center",
                      marginBottom: 10,
                    }}
                    title={<b>Forward Candidate Profile Information </b>}
                  >
                    <div className="center-align">
                      <Button
                        key="2-sendhost"
                        // htmlType="submit"
                        type="primary"
                        className="blue"
                        onClick={() => showModal(true)}
                        style={{
                          marginTop: 22,
                        }}
                      >
                        Send Host Email
                      </Button>
                      <Button
                        key="2-reject"
                        // htmlType="submit"
                        type="danger"
                        // className="blue"
                        onClick={() => showRejectionModal(true)}
                        style={{
                          marginTop: 22,
                          margin: "0 10px",
                        }}
                      >
                        Reject
                      </Button>

                      <SendHostEmail
                        show={visible && activeModal === modalType.PLACEMENT}
                        onShow={showModal}
                        userId={userId}
                        currentStatus={currentStatus}
                        setCurrentStatus={checkStatus}
                        intake={intake}
                        key="sendhostmodal"
                      />
                      <RejectCandidate
                        open={visible && activeModal === modalType.REJECT}
                        candidate={candidate}
                        setVisible={setVisible}
                        userId={userId}
                        currentStatus={currentStatus}
                        setCurrentStatus={checkStatus}
                        intake={intake}
                        key="rejectCandidate"
                      />
                    </div>
                  </Card>
                </Col>
                <Col span={8}></Col>
              </Row>
            </>
          )}
        </>
      )}

      {(currentStatus === "Placed" || currentStatus === "Exited") && (
        <>
          <h1 className="center-align">Exit Information</h1>
          <p className="sub-title center-align">View Exit Information</p>
          <br />

          <Form
            {...formItemLayout}
            name={formNameExit}
            form={formExit}
            onFinish={onSubmitExit}
            disabled={currentStatus === "Exited"}
          >
            <Row>
              <Col span={7}>
                <Form.Item
                  name="exitDirection"
                  label="Exit Direction"
                  rules={[
                    {
                      required: true,
                      message: "Please select exit direction",
                    },
                  ]}
                >
                  <Select onChange={onChangeExitDirection}>
                    {exitDirections.map((exitdirection) => (
                      <Option key={exitdirection.key}>
                        {exitdirection.value}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="effectiveDate"
                  label="Exit Date"
                  rules={[
                    {
                      required: true,
                      message: "Please pick exit date",
                    },
                  ]}
                >
                  <DatePicker
                    onChange={onDateChange}
                    // disabledDate={disabledDates}
                  />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item label=" ">
                  <Button
                    key="3"
                    htmlType="submit"
                    form={formNameExit}
                    type="primary"
                    hidden={currentStatus === "Exited"}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </>
  );
};

export default PlacementInformation;
